import React from 'react';
import { connect } from 'react-redux';
import Details from './details';
import Accessories from './../../accessories-kiosk/list';
import Advertisement from './advertisement';

const CategorySlider = props => {
  const { categoryMenuItemActiveKey } = props;
  return (
    <div>
      { categoryMenuItemActiveKey.includes('details') && <Details />}
      { categoryMenuItemActiveKey.includes('accessories') && <Accessories for='category' />}
      { categoryMenuItemActiveKey.includes('advertisement') && <Advertisement />}
    </div>
  );
}

export default connect(
  state => ({ categoryMenuItemActiveKey: state.ui.categoryMenuItemActiveKey })
)(CategorySlider);



// WEBPACK FOOTER //
// ./src/components/layout/content/catalog/category/category-info/index.js